// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DismissController from "./dismiss_controller"
application.register("dismiss", DismissController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import ErrorSummaryController from "./error_summary_controller"
application.register("error-summary", ErrorSummaryController)

import FullscreenController from "./fullscreen_controller"
application.register("fullscreen", FullscreenController)

import PwaController from "./pwa_controller"
application.register("pwa", PwaController)

import SuccessCheckController from "./success_check_controller"
application.register("success-check", SuccessCheckController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)
